export enum ChainEnum {
    Sanko = "Sanko",
    Arbitrum = "Arbitrum"
}

export const bridgeAddresses: Record<string, string> = {
    [ChainEnum.Sanko]: process.env.REACT_APP_SB_SANKO_CA || "",
    [ChainEnum.Arbitrum]: process.env.REACT_APP_SB_ARBITRUM_CA || "",
};

export const destinationChainId: Record<string, number> = {
    [ChainEnum.Sanko]: Number(process.env.REACT_APP_ARBITRUM_LZ_CHAIN_ID || "0"),
    [ChainEnum.Arbitrum]: Number(process.env.REACT_APP_SANKO_LZ_CHAIN_ID || "0"),
};